module.exports = __webpack_public_path__ + "static/media/celltype.87cde7f8.png";